<template>
  <div>
    <van-overlay :show="showLogin">
      <div class="login-block">
        <img class="loginClose" @click="clickColse" src="../../assets/img/icon-close.png"/>
        <div class="activity-login2" v-if="fontLogin.titleLogin">{{fontLogin.titleLogin}}</div>
        <van-form @submit="onSubmit">
          <van-field
            v-model="userPhone"
            type="tel"
            maxlength="11"
            name="用户名"
            center
            clearable
            placeholder="请输入手机号"
          />
          <van-field
            v-model="sms"
            type="digit"
            maxlength="6"
            name="验证码"
            center
            placeholder="请输入验证码"
          >
            <template #button>
              <div class="sendSms" :style="{color:(btnColor ? btnColor:'#f05259')}" @click="getCode"
                   v-if="showFont">发送验证码
              </div>
              <div class="sendSms" :style="{color:(btnColor ? btnColor:'#f05259')}" v-else>
                {{count}}s之后重新发送
              </div>
            </template>
          </van-field>
          <div class="btn-login">
            <div class="tips" v-if="fontLogin.tipsLogin"><img src="../../assets/img/icontip.png"/>{{fontLogin.tipsLogin}}
            </div>
            <van-button round block type="primary" native-type="submit"
                        :color="btnColor ? btnColor:'#f05259'"
                        size="large">
              {{fontLogin.btnLogin?fontLogin.btnLogin:'登录'}}
            </van-button>
          </div>
        </van-form>
      </div>
      <!--      </div>-->
    </van-overlay>
  </div>
</template>
<script>
  import md5 from 'js-md5';
  import type from '@/utils/type';
  import util from '@/utils/util';
  import {
    getSmscode,
    LOGIN,
  } from '@/apis/common';
  import {
    getAuditStatus,
  } from '@/apis/activity/common';

  export default {
    props: {
      showLogin: Boolean,
      shugen: Object,
      btnColor: String,
      fontLogin: Object,
      saveData: Boolean,
      saveCity: Boolean,
    },
    data() {
      return {
        userInfo: {},
        smsType: 0,
        userPhone: '',
        sms: '',
        showFont: true,
        count: '',
        timer: null,
        adcode: null,//当前城市
      };
    },
    watch: {
      // lists: {
      //   handler: function (val) {
      //     console.log(val);
      //   },
      //   deep: true
      // }
    },
    mounted() {
      if (this.saveCity) {
        this.getMyLocation();
      }
    },
    methods: {
      //第一部分
      //定位获得当前位置信息
      getMyLocation() {
        var geolocation = new qq.maps.Geolocation('S6VBZ-YHX6V-WQ6PB-URTSQ-C2FSF-JOFUE', '万顺叫车顺风车');
        // geolocation.getIpLocation(this.showPosition, this.showErr);
        geolocation.getLocation(this.showPosition, this.showErr);//或者用getLocation精确度比较高
      },
      showPosition(position) {
        this.adcode = position.adcode;
        console.log(position);
      },
      showErr() {
        this.getMyLocation();//定位失败再请求定位，测试使用
      },
      //登录弹出
      onStateLogin(val) {
        this.showLogin = !this.showLogin;
      },
      clickColse() {
        this.$emit('toLoginClose', false);
        this.userPhone = '';
        this.sms = '';
        this.showFont = true;
        this.count = '';
        this.timer = null;
      },
      onSubmit(values) {
        const reg = /^1[3456789]\d{9}$/;
        if (this.userPhone) {
          if (!reg.test(this.userPhone)) {
            return this.$toast('请输入正确手机号');
          }
        } else {
          return this.$toast('请输入手机号');
        }
        if (!this.sms) {
          return this.$toast('请输入验证码');
        }
        this.sendLogin();
      },
      async sendLogin() {
        let params = {
          channel: this.shugen.channel,
          deviceId: this.shugen.deviceId,
          platform: this.shugen.platform,
          softVersion: this.shugen.softVersion,
          sysVersion: this.shugen.sysVersion,
          deviceId: util.getUUID(),
          data: {
            loginType: 2,
            phone: this.userPhone,
            sms: this.sms,
          },
          token: null,
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await LOGIN(params);
          if (data.code == 1) {
            const userInfo = JSON.parse(data.data);
            userInfo.adcode = this.adcode;//当前定位并到userInfo
            // this.getAuditStatusFun(JSON.parse(data.data).token, userInfo);

            const showLogin = false;
            this.$storage.set('userInfo', userInfo);
            this.$emit('toLogin', showLogin, userInfo);
            this.userPhone = '';
            this.sms = '';
            this.showFont = true;
            this.count = '';
            this.timer = null;
          } else {
            this.$toast(data.msg);
          }
        } catch (error) {
        }
      },
      //不是代驾用户必须请求
      async getAuditStatusFun(token, userInfo) {
        let params = {
          channel: this.shugen.channel,
          deviceId: this.shugen.deviceId,
          platform: this.shugen.platform,
          softVersion: this.shugen.softVersion,
          sysVersion: this.shugen.sysVersion,
          token: token,
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await getAuditStatus(params);
          if (data.code == 1) {
            const showLogin = false;
            const userStatus = JSON.parse(data.data);
            if (this.saveData) {
              this.$storage.set('userInfo', userInfo);
              this.$storage.set('userStatus', userStatus);
            }
            this.$emit('toLogin', showLogin, userInfo, userStatus);
            this.userPhone = '';
            this.sms = '';
            this.showFont = true;
            this.count = '';
            this.timer = null;
          } else {
            this.$toast(data.msg);
          }
        } catch (error) {
        }
      },
      //发送验证码
      getCode() {
        const reg = /^1[3456789]\d{9}$/;
        if (this.userPhone) {
          if (!reg.test(this.userPhone)) {
            return this.$toast('请输入正确手机号');
          }
        } else {
          return this.$toast('请输入手机号');
        }


        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.showFont = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.showFont = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        this.sendSms();

      },
      async sendSms() {
        let params = {
          channel: this.shugen.channel,
          deviceId: this.shugen.deviceId,
          platform: this.shugen.platform,
          softVersion: this.shugen.softVersion,
          sysVersion: this.shugen.sysVersion,
          data: {
            userPhone: this.userPhone,
            smsType: this.smsType,
            signStr: md5(0 + '&:' + this.userPhone) +
              'DHHjTQf2ERQbw1oYXtBoqfnFeH1DcFv5Mr0f0B3vfao',
          },
          token: null,
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await getSmscode(params);
          if (data.code == 1) {

          }
        } catch (error) {
        }
      }
    }
  };
</script>
<style scoped lang="less">
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .login-block {
    background-color: #fff;
    border-radius: 10px;
    margin: 8.25rem 20px 0 20px;
    padding: 0 0 14px 0;
    position: relative;

    .loginClose {
      position: absolute;
      right: 16px;
      top: 16px;
      width: 12px;
      height: auto;
    }

    .activity-login2 {
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      padding: 10px;
      background: #FDFEFF;
      border-bottom: solid 1px #F1F2F5;
      border-radius: 10px 10px 0 0;
    }

    .login-close {
      width: 0.875rem;
      height: 0.875rem;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .sendSms {
      font-size: 1rem;
      font-weight: 400;
      /*color: #4C9D57;*/
      line-height: 1rem;
    }

    .btn-login {
      margin: 28px 0 0 0;

      .tips {
        font-size: 10px;
        font-weight: 400;
        color: #FF8427;
        line-height: 14px;
        padding-bottom: 7px;

        img {
          width: 13px;
          height: 13px;
          padding-right: 9px;
          position: relative;
          top: 2px;
        }
      }
    }

    .van-form {
      margin: 0 15px;
    }

    .van-cell {
      margin: 20px 0 0 0;
      padding: 0.938rem 1rem;
      border: solid 1px #F0F1F5;
      box-sizing: border-box;
      border-radius: 6px;
    }

    .van-cell::after {
      border: none;
    }

    .van-field__control {
      font-size: 1rem;
      font-weight: 400;
      color: #999999;
    }
  }

  .van-button--round {
    border-radius: 10px;
  }
</style>
